import i18n from '../i18n';
import { normalizeUiLocale } from './locale';

// 体征标签的唯一来源是 locale 的 checkTypes 命名空间。这里按会诊语言取 t，
// 使同一份数据在会诊记录和小屋检查列表里渲染出一致的标签。
const fixedT = (language) => i18n.getFixedT(normalizeUiLocale(language, 'en-US'));

const humanizeFallback = (value) => {
  const text = String(value || '').trim();
  if (!text) {
    return '';
  }
  return text
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
};

const getPayloadLabel = (metadata, language) => {
  if (!metadata || typeof metadata !== 'object') {
    return '';
  }

  const candidates = normalizeUiLocale(language, 'en-US') !== 'en-US'
    ? [
      metadata.name_local,
      metadata.label_local,
      metadata.label_zh,
      metadata.zh,
      metadata.label,
      metadata.name,
    ]
    : [
      metadata.name_en,
      metadata.label_en,
      metadata.en,
      metadata.label,
      metadata.name,
    ];

  return candidates.find((candidate) => String(candidate || '').trim()) || '';
};

export const formatVitalSignLabel = (key, language, metadata = {}) => {
  const payloadLabel = getPayloadLabel(metadata, language);
  if (payloadLabel) {
    return payloadLabel;
  }

  const normalizedKey = String(key || '').trim();
  if (!normalizedKey) {
    return '';
  }
  return fixedT(language)(`checkTypes.${normalizedKey}`, {
    defaultValue: humanizeFallback(normalizedKey),
  });
};

export const formatSourceLabel = (source, language) => {
  const normalizedSource = String(source || '').trim();
  if (!normalizedSource) {
    return '';
  }
  return fixedT(language)(`checkSources.${normalizedSource}`, {
    defaultValue: humanizeFallback(normalizedSource),
  });
};
